export default "__VITE_ASSET__CmArW37Z__"